import { useSessionStorage } from '@vueuse/core'
import type { ZoneSecret } from '~/api'
import { ZONE } from '~/constants'

export function useZone() {
  const zone = useSessionStorage<ZoneSecret>(ZONE, {}, { flush: 'sync' })
  return zone
}
